// phoneRegex: allows phone numbers + some special characters for formatting;
// for example: 06-12.34.56.78 is valid
const phoneRegex = /^\+?[0-9 -\.]{2}\(?\+?[0-9 -\.]{1,4}\)?[0-9 -()\.]{5,}$/

export const isValidPhone = (value?: string): string | void => (value && !phoneRegex.test(value) ? 'global.not_a_valid_phone' : undefined)
